/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { BotonExportarExcel, downloadFile } from "../../shared";

// Descarga la planilla Excel con los productos del proceso: los emitidos con
// sus modificaciones pendientes en la columna Notas y, al final, los que
// todavía no se emitieron. La arma la API; no se exporta lo que se ve.
export function descargarPlanillaProductos(pasoId, proceso, alTerminar, alFallar) {
  // Arma el nombre del archivo con el cliente y el proceso, sin caracteres
  // que no puedan ir en un nombre de archivo
  const nombreArchivo = ["Productos", proceso.cliente?.razonsocial, proceso.nombre]
    .filter(Boolean)
    .join(" - ")
    .replace(/[\\/:*?"<>|]/g, "-");
  downloadFile(`colab/actividad/${pasoId}/productos/excel`, `${nombreArchivo}.xlsx`, alTerminar, alFallar);
}

// Botón de Excel (el mismo de las tablas) para las cards de productos que no
// son una tabla
export default function BotonDescargarProductos({ pasoId, proceso, productos }) {
  const [loader, setLoader] = useState(false);
  const toast = useRef(null);

  function descargarProductos() {
    setLoader(true);
    descargarPlanillaProductos(
      pasoId,
      proceso,
      () => setLoader(false),
      () => {
        setLoader(false);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "No se pudo descargar la planilla de productos",
          sticky: true,
        });
      }
    );
  }

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <BotonExportarExcel data={productos} exportar={descargarProductos} exportando={loader} />
    </>
  );
}
